import {fetchUserByAccountNumber, User} from '@deviceinsight/ng-ui-api-client';
import {useState, useEffect} from 'react';

const useGetUserByAccountNumber = (createdBy: string) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [user, setUser] = useState<User | null | undefined>();
	useEffect(() => {
		if (createdBy) {
			setLoading(true);
			fetchUserByAccountNumber(createdBy)
				.then(setUser)
				.catch((err) => {
					console.error('User could not be loaded: ', err);
				})
				.finally(() => setLoading(false));
		}
	}, [createdBy]);
	return {
		loading,
		user
	};
};

export default useGetUserByAccountNumber;
